<template>

  <div class="mt-5 mb-5mr-10 pr-5" align="center">
   
    <v-card
            class="ml-5 mb-10 pt-3 pl-5 pr-5"
            height="100%"
            outlined
        >
                <v-img
                height="125"
                width="125px"
                :src="imageURL"
                
                >
                    
                </v-img>

                <v-card-subtitle align="center" class="pl-6 pr-8 mt-1 mb-0 font-weight-black black--text cardHeading">{{ typeNumber + ". " + typeName }}</v-card-subtitle>

                <v-card-text>
            
                  <v-row class="text-left black--text">
                    <v-col cols="12">
                    {{ summary }}
                    </v-col>
                  </v-row>

                  <v-row class="text-left">
                    <v-col cols="12">
                    {{ overView }}
                    </v-col>
                  </v-row>

          

                  <v-tabs
                      fixed-tabs
                      background-color="white"
                      
                    >
                      <v-tab>
                        Motivations
                      </v-tab>
                      <v-tab>
                        Integrations
                      </v-tab>
                      <v-tab>
                        More
                      </v-tab>
                      
                      <v-tab-item
                      >
                        <v-card
                          flat
                          tile
                          align="left"
                        >
                          <v-card-text> {{ keyMotivators }}</v-card-text>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item
                      >
                        <v-card
                          flat
                          tile
                        >
                          <v-card-text>Coming Soon</v-card-text>
                        </v-card>
                      </v-tab-item>

                       <v-tab-item
                      >
                        <v-card
                          flat
                          tile
                        >
                          <v-card-text>Coming Soon</v-card-text>
                        </v-card>
                      </v-tab-item>


                    </v-tabs>



                </v-card-text>

                <v-card-actions class="card-actions">


                </v-card-actions>

                
                
        </v-card>


  </div>
</template>

<script>
import enneagramDescriptions from "../assets/enneagram.json";


export default {
  name: 'EnneagramTypeDetail',

  props: {
    typeNumber: {
      type: Number,
      default: 1
      }
  },

  methods: {

  },

  computed: {

      imageURL() {
        return this.enneaDescriptions[this.typeNumber-1].imageURL
      },

      typeName() {
        return this.enneaDescriptions[this.typeNumber-1].typeName
      },

      summary() {
          return this.enneaDescriptions[this.typeNumber-1].summary
      },

      overView() {
          return this.enneaDescriptions[this.typeNumber-1].overview
      },

      keyMotivators() {
          return this.enneaDescriptions[this.typeNumber-1].keyMotivations
      },

      enneaDescriptions() {
        return enneagramDescriptions.enneagramTypes.map((item) => {
          return item;
        })
      }
  },
  data: function () {
    return {
      
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>

.cardHeading {
    color: black;
    font-size: 24pt;
    line-height: 1.2;
}




</style>
